module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "session-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "session-right text-xs-center"
  }, [_c('div', {
    staticClass: "session-table-cell"
  }, [_c('div', {
    staticClass: "div-icon mb-3 pointer",
    on: {
      "click": _vm.goHome
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.jpg",
      "width": "78",
      "height": "78"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 mb-3"
  }, [_c('div', {
    staticClass: "font-lg mb-5"
  }, [_vm._v(_vm._s(_vm.$t("activation.valid")))]), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "round": "",
      "flat": "",
      "outline": "",
      "large": "",
      "color": "aquamarine"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("page404.homepageButton")))])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "session-left"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/graphic1.svg"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce15a7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkInvalid.vue
// module id = 443
// module chunks = 0